import React, { Fragment } from "react"
import { useLocation, useParams } from "react-router-dom"
import List from "./List"
import PatientStats from "./PatientStats"

const MisPacientes = () => {
  const { pathname } = useLocation()
  const { userId } = useParams()

  // Determinar qué mostrar basado en la ruta
  const showList = pathname === "/mis-pacientes"
  const showStats = pathname.includes("/mis-pacientes/ver/")

  if (showList) {
    return (
      <Fragment>
        <h1 className="d-flex justify-content-center align-items-center mb-4">
          Mis Pacientes
        </h1>
        <List />
      </Fragment>
    )
  }

  if (showStats && userId) {
    return (
      <Fragment>
        <h1 className="d-flex justify-content-center align-items-center mb-4">
          Estadísticas del Paciente
        </h1>
        <PatientStats userId={parseInt(userId)} />
      </Fragment>
    )
  }

  return <div>No encontrado</div>
}

export default MisPacientes
